<template>
  <div class="not-found full-screen">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <img src="@/assets/static/img/plyo-logo.svg" alt="..." @click="onClickLogo" />
      </div>
    </nav>
    <div class="wrapper wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-4 offset-md-2">
            <div class="oops-title">{{ oops_title }}</div>
            <div class="explainer-title">{{ explainer_title }}</div>
            <div class="error-code">{{ error_code }}</div>
            <div class="helpful-links">
              <div class="helpful-links-title">{{ helpful_links_title }}</div>
              <ul class="helpful-links-list">
                <li v-for="helpful_link in helpful_links" :key="helpful_link.title">
                  <div class="helpful-link" @click="onHelpfulLinkClicked(helpful_link.link)">{{ helpful_link.title }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        oops_title: 'Oops!',
        explainer_title: "We can't seem to find the page you're looking for.",
        error_code: 'Error code: 404',
        helpful_links_title: 'Helpful Links',
        helpful_links: [
         { title: 'Analytics', link: '/analytics', },
         { title: 'Rewards', link: '/rewards', },
         { title: 'Profile', link: '/profile', },
         { title: 'Support', link: '/support', }, 
        ]
      }
    },
    methods: {
      onHelpfulLinkClicked(link) {
        this.$router.push(link)
      },
      onClickLogo() {
        this.$router.push('/')
      },
    },
  }

</script>
